var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27045 20.4437C0.977528 20.1507 0.812972 19.7534 0.812972 19.339C0.812972 18.9247 0.977528 18.5274 1.27045 18.2344L9.00483 10.5L1.27045 2.76561C0.985831 2.47092 0.828339 2.07623 0.831899 1.66654C0.835459 1.25686 0.999786 0.864965 1.28949 0.575265C1.57919 0.285565 1.97108 0.121241 2.38076 0.117681C2.79045 0.114121 3.18514 0.271612 3.47983 0.556234L12.3189 9.3953C12.6118 9.68831 12.7764 10.0857 12.7764 10.5C12.7764 10.9143 12.6118 11.3117 12.3189 11.6047L3.47983 20.4437C3.18681 20.7367 2.78946 20.9012 2.37514 20.9012C1.96082 20.9012 1.56346 20.7367 1.27045 20.4437Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5bfd4ea7e1e61708c208bf66b0d90d96.svg";
export { ForwardRef as ReactComponent };